// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminApplications = (client) => ({
    /**
     * `POST /admin/applications/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdApproveCreate
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsCreate
     * @source packages/modules/b2c-core/src/api/admin/applications/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/applications", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/applications/:id/categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAttachApplicationCategories
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/categories/route.ts
     */
    createCategory: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/categories", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAttachProductsToApplication
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/products/route.ts
     */
    createProduct: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/products", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdDelete
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/applications/:id/categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDetachApplicationCategories
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/categories/route.ts
     */
    deleteCategory: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/categories", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDetachProductsFromApplication
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/products/route.ts
     */
    deleteProduct: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/products", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsList
     * @source packages/modules/b2c-core/src/api/admin/applications/route.ts
     */
    list: (query, headers) => client.fetch("/admin/applications", { method: "GET", query, headers }),
    /**
     * `GET /admin/applications/:id/categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetApplicationCategories
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/categories/route.ts
     */
    listCategories: (id, query, headers) => client.fetch(buildPath("/admin/applications/:id/categories", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetApplicationProducts
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/admin/applications/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/applications/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdRejectCreate
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdRetrieve
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/applications/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/applications/:id/seo-content`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdSeoContentRetrieve
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/seo-content/route.ts
     */
    retrieveSeoContent: (id, query, headers) => client.fetch(buildPath("/admin/applications/:id/seo-content", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdUpdate
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `PUT /admin/applications/:id/seo-content`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApplicationsIdSeoContentUpdate
     * @source packages/modules/b2c-core/src/api/admin/applications/[id]/seo-content/route.ts
     */
    updateSeoContent: (id, body, query, headers) => client.fetch(buildPath("/admin/applications/:id/seo-content", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=applications.js.map